import React, {Suspense, lazy} from 'react';
import { PageLoading } from '../../Components/Loading';

const TheAddCard = lazy(() => import(/* webpackChunkName: "stripe" */'./TheAddCard'));

const AddCard = (params) => {

    return <Suspense fallback={<PageLoading />}>
        <TheAddCard {...params} />
    </Suspense>
}

export default AddCard;
